import React, { Component } from 'react'
import { connect } from 'react-redux';

const mapStateToProps = state => {
    return {
      ...state.common
    }
};

class LoadingCircularBar extends Component {
    render(){
        if(this.props.loading)
            return (
                <div className="loadWrap">
                    <div className="loadIco"><div className="lds-css ng-scope"><div style={{ width: "100%", height: "100%" }} className="lds-rolling"><div style={{ maxWidth : "none" }}></div></div></div></div>
                    <div className="bg"></div>
                </div>
            )
        else 
            return "";
    }
}

export default connect(mapStateToProps)(LoadingCircularBar);


// WEBPACK FOOTER //
// ./src/components/common/loadingCircularBar.js